import Tags from '../Tags';
import TripTimerCaption from './TripTimerCaption';

type Props = {
  startAt?: string | null;
};

function DataPendingTag({ startAt }: Props): JSX.Element {
  return (
    <Tags.Label
      label="Data pending"
      caption={startAt ? <TripTimerCaption startAt={startAt} /> : undefined}
    />
  );
}

export default DataPendingTag;
